import { render } from "./TIActiveIcon.vue?vue&type=template&id=b0c1a56e"
import script from "./TIActiveIcon.vue?vue&type=script&lang=js"
export * from "./TIActiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__